export default "/images/analytics.svg?7ed9968cd84eaef737a1379ee0c8722b";